import { ChangeDetectionStrategy, Component, input, InputSignal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { STATUS_TYPES, StatusType } from "@shared/types/status.types";

@Component({
  selector: "app-shared-notify-chip",
  templateUrl: "./notify-chip.component.html",
  styleUrl: "notify-chip.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class NotifyChipComponent {
  public status: InputSignal<StatusType> = input<StatusType>(STATUS_TYPES.success);
}
